import { GIFT_CATEGORY } from '../configs/config';

type Link = 'LOGIN' | 'PERSONAL_INQUIRY' | 'PRODUCT' | 'HOME' | 'REVIEW' | 'GIFT_CATEGORY';

const deepLinkUrl: Record<Link, string> = {
  LOGIN: 'kurly://login',
  PERSONAL_INQUIRY: 'kurly://compose/inquiry',
  PRODUCT: 'kurly://product?no=',
  GIFT_CATEGORY: `kurly://category?no=${GIFT_CATEGORY}`,
  HOME: 'kurly://home',
  REVIEW: 'kurly://compose/review',
} as const;

export default deepLinkUrl;
